module.exports = __webpack_public_path__ + "img/p7.055f7e23.png";